<template>
  <div class="page-content">
    <div class="headings">
      <h3>{{ $t("lang.dashboard.printer_production") }}</h3>
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
              <br><br/>

        <v-row>
          <v-col>
            <v-select
              v-model.lazy="areaSelected"
              :items="locations"
              color="#FF5800"
              :label="$t('lang.admin.device_form.label_select_location')"
              item-color="#FF5800"
              item-text="description"
              item-value="id"
              outlined
            >
            </v-select>
          </v-col>

          <div class="select-box col-md-6">
              <v-select
                :items="order_states"
                v-model="filter_state"
                prefix="Filter state:   "
                outlined
              ></v-select>
            </div>


          <v-col class="d-flex justify-content-center" md="auto">
            <v-btn
              color="#FF5800"
              class="px-10"
              style="height: 55px"
              @click="submit"
              :loading="shouldLoading"
              :disabled="shouldLoading"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                ordersCount + ' ' + $t('lang.inventory.stocks.table_title')
              "
              no-padding
              :loading="shouldLoading"
            >
              <skeleton-table :columns="7" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="ordersCount"
                @search="onSearch"
                highlight-danger="quantity"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column field="state" centered>
                    <bx-order-nice-status
                      :status="props.row.state"
                    ></bx-order-nice-status>
                  </bx-table-column>

                  <bx-table-column centered>{{ props.row.id }}</bx-table-column>
                  <bx-table-column centered>{{ props.row.creation_date }}</bx-table-column>

                  <bx-table-column style="width: 150px;" field="order" centered >
                    <router-link :to="`/inbound/order/${props.row.order}/detail`" class="bx-link bx-link-bold">
                      {{ props.row.order }}
                    </router-link>
                  </bx-table-column>
                  <bx-table-column centered>{{ props.row.item_count }}</bx-table-column>
                  <bx-table-column>
                    <img
                      @click="downloadFile(props.row.order)"
                      style="cursor: pointer"
                      src="@/assets/i/Icon-download.svg"
                    />
                  </bx-table-column>
                  <bx-table-column centered style="width: 100px;">
                    <div style="width: 150px;">
                      <v-select
                        style="margin-top: 0px"
                        dense
                        hide-details=""
                        :items="order_states"
                        v-model="props.row.state"
                        @change="onChangeOrderState($event, props.row.id)"
                      ></v-select>
                    </div>
                  </bx-table-column>
                </template>
              </bx-table>
            </bx-box>
            <v-snackbar
              :color="snackbarColor"
              v-model="snackbar"
              timeout="5000"
              top
              right
            >
              {{ snackbarText }}
            </v-snackbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let order_states = [
  { value: 0, text: "Pending" },
  { value: 1, text: "In progress" },
  { value: 2, text: "Completed" },
];
export default {
  name: "inbound-dashboard",
  data() {
    return {
      shouldLoading: true,
      reloadInterval: null,
      columns: [],
      data: [],
      key: "inventory_stocks",
      filters: [],
      pending: 0,
      completed: 0,
      total: 0,
      page: 1,
      ordersCount: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      areaList: [],
      locations: [],
      filter_state: null,
      areaSelected: [],
      snackbar: false,
      order_states: order_states,

      snackbarText: "",
      snackbarColor: "#FF5800",
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    async getLocations() {
      this.locations = await this.$api.brand.locations();
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      this.filters[field] = value;
      this.getData();
    },
    async downloadFile(order) {
      try {
        await this.$api.printer.download_nicelabel(order);
      } catch (error) {
        console.log(error);
      }
    },
    onChangeOrderState(value, id) {
      try {
        this.$api.printer.update_nicelabel_state({
          id: id,
          state: value
        });
      } catch (error) {
        console.error(error);
      }
    },
    updatePage(p) {
      this.page = p;
      this.submit();
      // this.data = []
    },
    async getData() {
      try {
        await this.getLocations();
        this.columns = [
          {
            field: "state",
            label: this.$t("lang.common.state"),
            witdh: 50,
          },
          {
            field: "id",
            label: this.$t("lang.common.id"),
            centered: true,
          },
          {
            field: "creation_date",
            label: this.$t("lang.common.creation_date"),
            centered: true,
          },
          {
            field: "order",
            label: this.$t("lang.brand_page.porders_title"),
            centered: true,
            filter: {
              placeholder: this.$t("lang.inventory.stocks.table_field_1"),
              value: this.filters.gtin,
            },
            witdh: 15
          },
          {
            field: "item_count",
            label: this.$t("lang.common.quantity"),
          },
          {
            field: "download",
            label: this.$t("lang.common.download"),
            centered: true,
          },
          {
            field: "state",
            label: this.$t("lang.common.state"),
            witdh:100
          },
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.shouldLoading = false;
      }
    },
    async submit() {
      this.shouldLoading = true;
      const inventories = await this.$api.printer.nicelabel_get(
        this.areaSelected,
        {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
        }
      );
      if (inventories.results.length) {
        this.ordersCount = inventories.count;
        this.data = inventories.results.map((item) => {
          return {
            id: item.id,
            order: item.order.order_code,
            state: item.state,
            creation_date: item.order.creation_date,
            item_count: item.order.item_count

          };
        });
      } else {
        this.number_of_stock = 0;
        this.ordersCount = inventories.count;
        this.number_of_gtin = 0;
        this.data = [];
        this.snackbarText = "No results found";
        this.snackbarColor = "red darken-2";
        this.snackbar = true;
      }
      this.shouldLoading = false;
    },
  },
  async mounted() {
    this.getData();
    this.filters.gtin = this.$session.get(this.key + "gtin");
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  },
};
</script>
